<template>
  <CFooter :fixed="false">
    <div>تمام حقوق مادی و معنوی برای ارتباطات گام دوم محفوظ است.</div>
    <div class="mfs-auto"></div>
  </CFooter>
</template>

<script>
export default {}
</script>
